import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export const SectionParallax = () => {

  const box = document.querySelector('.section__parallax');
  if (box) {
    // const layers = document.querySelectorAll('.section__parallax__layer');

    let layers = gsap.utils.toArray(".section__parallax__layer");

    if (box) {
      const pictureHeight = box.offsetHeight;
      const heightDiff = box.offsetHeight/3;

      gsap.fromTo(layers,{
        y: 0,
        scale: 1,
      }, {
        scrollTrigger: {
          scrub: true,
          top: 'top top',
          end: `+=${pictureHeight*3} top`,
          // markers: true
        },
        y: heightDiff,
        scale: 4,
        ease: "none"
      });
    }
  }
}
